import { render } from "./AchieveAddOtherIncome.vue?vue&type=template&id=94337e76&scoped=true"
import script from "./AchieveAddOtherIncome.vue?vue&type=script&lang=js"
export * from "./AchieveAddOtherIncome.vue?vue&type=script&lang=js"

import "./AchieveAddOtherIncome.vue?vue&type=style&index=0&id=94337e76&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94337e76"]])

export default __exports__